type UpdateCondition<T> = (item: T) => boolean;
type UpdateData<T> = Partial<T>;

export function updateArray<T>(
  array: T[],
  condition: UpdateCondition<T>,
  update: UpdateData<T>
): T[] {
  return array.map((item) => {
    if (condition(item)) {
      return { ...item, ...update };
    }
    return item;
  });
}
